<template>
  <div
    v-if="loading || !dataExists"
    class="rbz-loader"
    data-qa="rbz-loader"
    :style="{ height: height, ...style }"
  >
    <template v-if="loading">
      <div
        class="spinner is-loading"
        data-qa="spinner"
        :style="`--spinner-size:${loaderSize}; --spinner-width:8px`"
      ></div>
    </template>
    <template v-else>
      <template v-if="$slots.noDataOverride">
        <slot name="noDataOverride" />
      </template>
      <template v-else>
        {{ noDataMessageWithDefaults }}
      </template>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import _ from 'lodash';
import { GenericObject } from '@/types';

const { t } = useI18n();

interface RbzLoader {
  loading: boolean;
  dataExists: boolean;
  noDataMessage?: string;
  height?: string;
  style?: GenericObject;
  loaderSize?: string;
}

const props = withDefaults(defineProps<RbzLoader>(), {
  height: '80px',
  loaderSize: '80px',
});

const noDataMessageWithDefaults = computed(() => {
  if (!_.isNil(props.noDataMessage)) {
    return props.noDataMessage;
  } else {
    return t('common.noDataMessage');
  }
});
</script>

<style scoped lang="scss">
@use 'ui-component-library/assets/styles/colors' as colors;
@use 'sass:map';

.rbz-loader {
  align-items: center;
  background: map.get(colors.$colors, 'white');
  display: flex;
  font-size: 14px;
  justify-content: center;
  left: 0;
  line-height: 18px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 100;
}
</style>
